window.loadLanguageSwitcher = function (showOverride) {
  'use strict';
  var hreflangs = {};

  $('link[rel="alternate"]').each(function (i, el) {
    hreflangs[el.hreflang] = el.href;
  });

  var allLangs = [{
    lang: 'en',
    text: 'English',
    href: hreflangs.en
  }, {
    lang: 'de',
    text: 'Deutsch',
    href: hreflangs.de
  }, {
    lang: 'es',
    text: 'Español',
    href: hreflangs.es
  }, {
    lang: 'fr',
    text: 'Français',
    href: hreflangs.fr
  }, {
    lang: 'ja',
    text: '日本語',
    href: hreflangs.ja
  }];

  // when ready, update original language dropdown links and reset to show language switcher bar
  $(function () {
    $('ul.tsc-language a').each(function (i, el) {
      if (allLangs[i].href) {
        $(el).prop('href', allLangs[i].href);
      }
    }).on('click', function (e) {
      localStorage.removeItem('langSwitcher');
    });
  });

  if (!$(document.body).hasClass('responsive')) { return; }

  if (!showOverride && localStorage.getItem('langSwitcher') === 'hide') { return; }

  var docLang = document.documentElement.lang || '';
  var docLangMatch = docLang.match(/^(?:de|en|es|fr|ja)/);
  var currentLanguage = docLangMatch && docLangMatch[0];

  if (!currentLanguage) { return; }

  var browserLanguages = navigator.languages || [ navigator.language ];

  var supportedLanguages = allLangs.filter(function (lang) {
    return lang.href;
  });

  var languageMatch = browserLanguages.map(function (lang) {
    var match = lang && lang.match(/^(?:de|en|es|fr|ja)/i);
    return match && hreflangs[match[0]] ? match : null;
  }).find(function (match) { return match; });

  if (!languageMatch) { return; }

  var preferredSupportedLanguage = languageMatch[0];

  if (!hreflangs[preferredSupportedLanguage]) { return; }

  if (!showOverride && currentLanguage === preferredSupportedLanguage) { return; }

  var translations = {
    de: {
      directLink: ['Möchten Sie diese Seite auf <a href="', hreflangs.de, '">Deutsch</a> lesen?'].join(''),
      viewAllLangs: 'Alle Sprachen anzeigen:'
    },
    en: {
      directLink: ['Do you want to view this page in <a href="', hreflangs.en, '">English</a>?'].join(''),
      viewAllLangs: 'View all languages:'
    },
    es: {
      directLink: ['¿Quieres ver esta página en <a href="', hreflangs.es, '">Español</a>?'].join(''),
      viewAllLangs: 'Ver todos los idiomas:'
    },
    fr: {
      directLink: ['Voulez-vous vraiment afficher cette page en <a href="', hreflangs.fr, '">Français</a>?'].join(''),
      viewAllLangs: 'Voir toutes les langues:'
    },
    ja: {
      directLink: ['このページを<a href="', hreflangs.ja, '">日本</a>で表示しますか?'].join(''),
      viewAllLangs: 'すべての言語を表示'
    }
  };

  var templateLang = translations[preferredSupportedLanguage];

  var template = [
    '<div class="language-switcher">',
      '<div class="ls-layout">',
        '<div class="ls-view-in-lang">',
          '<div class="ls-view-in-lang-align">',
            '<span class="ls-view-in-lang-text">', templateLang.directLink, '</span>',
          '</div>',
        '</div>',
        '<div class="ls-separator"></div>',
        '<div class="ls-all-langs">',
          '<span class="ls-all-langs-label">', templateLang.viewAllLangs, '</span>',
            // important, no white-space here
            '<div class="ls-all-langs-positioner">',
            '<button type="button" class="ls-all-langs-current">',
                '<i class="glyph-nav-world"></i> <span>English</span> <i class="glyph-chevron-down glyph-small"></i>',
            '</button>',
            '<div class="ls-all-langs-dropdown">',
              '<ul class="ls-all-langs-menu">',
                 supportedLanguages.map(function (props) {
                   var selected = currentLanguage === props.lang ? ' class="ls-selected" tabindex="-1"' : '';
                   return ['<li><a href="', props.href, '"', selected, '>', props.text, '</a></li>'].join('');
                 }).join(''),
              '</ul>',
            '</div>',
          '</div>',
        '</div>',
        '<div class="ls-close">',
          '<button type="button" class="ls-close-button"></button>',
        '</div>',
      '</div>',
    '</div>'
  ].join('');

  var $langSwitcher = $(template);

  $langSwitcher.prependTo('.slider');

  var isOpen = false;
  var autoCloseDelay = 1000;
  var autoCloseTimeout = null;
  var $positioner = $langSwitcher.find('.ls-all-langs-positioner');
  var $dropdownButton = $positioner.children('.ls-all-langs-current');
  var $dropdownMenu = $dropdownButton.next().children('.ls-all-langs-menu');
  var $closeButton = $langSwitcher.find('.ls-close-button');

  $dropdownButton.on('click', function (e) {
    isOpen = !isOpen;
    $dropdownMenu.toggleClass('ls-visible', isOpen);
  });

  $positioner.on('mouseleave', function (e) {
    if (!isOpen) { return; }
    autoCloseTimeout = setTimeout(function () {
      if (!isOpen) { return; }
      isOpen = false;
      $dropdownMenu.toggleClass('ls-visible', isOpen);
    }, autoCloseDelay);
  });

  $positioner.on('mouseenter', function (e) {
    if (!isOpen) { return; }
    clearTimeout(autoCloseTimeout);
  });

  $(document).on('click', function (e) {
    if (!isOpen) { return; }
    var jQclickedElement = $(e.target);
    if (jQclickedElement.closest($positioner).length === 0) {
      isOpen = false;
      $dropdownMenu.toggleClass('ls-visible', isOpen);
    }
  });

  $closeButton.on('click', function () {
    localStorage.setItem('langSwitcher', 'hide');
    $langSwitcher.addClass('ls-hide');
  });
};
